import React, { createContext, useContext, useState } from 'react';

const StreamContext = createContext();

const StreamManager = ({ children }) => {

    const [activeStreams, setActiveStreams] = useState([]);

    const startStream = (stream) => {

        setActiveStreams(prevStreams => [...prevStreams, stream]);
    };

    const stopStream = (stream) => {

        stream.getTracks().forEach(track => {

            track.stop()
        });
        setActiveStreams(prevStreams => prevStreams.filter(s => s !== stream));
    };

    const stopAllStreams = () => {

        activeStreams.forEach(stream => stopStream(stream));
    };

    const contextValue = {
        startStream,
        stopStream,
        stopAllStreams,
    };

    return (
        <StreamContext.Provider value={contextValue}>
            {children}
        </StreamContext.Provider>
    );
};

const useStreamManager = () => {
    const context = useContext(StreamContext);
    if (!context) {
        throw new Error('useStreamManager must be used within a StreamManager');
    }
    return context;
};

export { StreamManager, useStreamManager };